import React from 'react'

import { AutomobileVehicleSelection } from 'containers/AutomobileVehicleSelection'
import AssetType from 'state/enums/AssetType'

import { FieldConfigBase, FieldProps } from '../../containers/FormBuilder'

export interface AutomobileVehicleSelectionBaseFieldConfig extends FieldConfigBase {
    assetType: AssetType
    prefilled?: boolean
}

export default function AutomobileVehicleSelectionBaseField(
    props: FieldProps<AutomobileVehicleSelectionBaseFieldConfig>,
) {
    const { fieldConfig, fieldKit } = props

    return (
        <AutomobileVehicleSelection
            assetType={fieldConfig.assetType}
            formik={fieldKit}
            prefilled={fieldConfig.prefilled}
        />
    )
}
